import GuestListPageContainer from './containers/GuestListPageContainer'

export default GuestListPageContainer
